export default function getUserFullName(user) {
  if (!user) {
    return null
  }

  let fullName = user.first_name || ''
  if (user.last_name) {
    fullName = fullName.concat(` ${user.last_name}`)
  }

  return fullName
}
